<app-notificator></app-notificator>
<app-loader></app-loader>
<app-overlay></app-overlay>
<router-outlet></router-outlet>
<app-product-card></app-product-card>